import { useRef } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Link } from '@flipster/i18n/routing';
import { Styles, css, cx } from '@flipster/styled-system/css';
import { richText as richTextRecipe } from '@flipster/styled-system/recipes';

import { Accordion } from '../../../shared/faq-accordion';

export const Faq = ({ css: cssProp }: { css?: Styles }) => {
  const intersectionRef = useRef<HTMLHeadingElement>(null);
  const recipe = richTextRecipe({ style: 'custom' });

  return (
    <section className={css(cssProp)}>
      <h2 ref={intersectionRef} className={css({ mb: { base: 32, tablet: 40 }, textStyle: 'Title/M' })}>
        <FormattedMessage id='Common.r251107.Faq' />
      </h2>
      <Accordion.Root headingLevel={2} css={{ mb: { base: 32, tablet: 40 } }}>
        {contents.map((content, index) => (
          <Accordion.Item key={index} css={{ px: 0 }}>
            <Accordion.Header index={index + 1}>{content.title}</Accordion.Header>
            <Accordion.Panel>
              <div className={cx(recipe, css({ textStyle: 'Text/L/Regular', color: 'content.default.level-2' }))}>
                {content.desc}
              </div>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </section>
  );
};

const contents = [
  {
    title: <FormattedMessage id='Copy.r251107.What_is_copy_trading_how_to_use_question' />,
    desc: (
      <p>
        <FormattedMessage id='Copy.r251107.What_is_copy_trading_how_to_use_answer' />
        {'\n'}
        <Link href='/blog/what-is-copy-trading-in-crypto'>
          <FormattedMessage id='Common.r250401.Learn_more' />
        </Link>
      </p>
    ),
  },
  {
    title: <FormattedMessage id='Copy.r251107.How_copy_trading_execute_manage_question' />,
    desc: (
      <p>
        <FormattedMessage id='Copy_trading.r260211.The_system_mirrors_every_open_and_close_order_from_your_selected_master_trader_b_description' />
        {'\n'}
        <Link href='/blog/how-to-use-copy-trading-on-flipster'>
          <FormattedMessage id='Common.r250401.Learn_more' />
        </Link>
      </p>
    ),
  },
  {
    title: <FormattedMessage id='Copy.r251107.How_profits_fees_settlements_handled_question' />,
    desc: (
      <>
        <p>
          <FormattedMessage id='Copy.r251107.How_profits_fees_settlements_handled_answer' values={{ percent: '15%' }} />
          {'\n'}
          <Link href='/blog/how-to-use-copy-trading-on-flipster'>
            <FormattedMessage id='Common.r250401.Learn_more' />
          </Link>
        </p>
        <p className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-2' })}>
          <FormattedMessage id='Copy.r260312.This_figure_is_indicative_and_is_subject_to_the_master_trader_terms' />
        </p>
      </>
    ),
  },
  {
    title: <FormattedMessage id='Copy.r251107.What_copy_trading_performance_metrics_question' />,
    desc: (
      <p>
        <FormattedMessage id='Copy.r251107.What_copy_trading_performance_metrics_answer' />
        {'\n'}
        <Link href='/blog/a-complete-guide-to-copy-trading-performance-indicators-on-flipster'>
          <FormattedMessage id='Common.r250401.Learn_more' />
        </Link>
      </p>
    ),
  },
  {
    title: <FormattedMessage id='Copy.r251107.What_risks_safety_measures_question' />,
    desc: (
      <p>
        <FormattedMessage id='Copy.r251107.What_risks_safety_measures_answer' />
        {'\n'}
        <Link href='/blog/what-is-copy-trading-in-crypto'>
          <FormattedMessage id='Common.r250401.Learn_more' />
        </Link>
      </p>
    ),
  },
];
